import Api from 'api/index';
import { useForm } from 'react-hook-form';
import useLazyQuery from 'utils/useLazyQuery';
import { useTranslation } from 'react-i18next';
import RadioButton from 'components/Form/Radio';
import Form from 'components/Form';
import Button from 'components/Button';
import Tracker from 'utils/Tracking';
import { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import FeatureFlag from 'containers/Shared/components/FeatureFlag';
import { config } from 'config';

const GOOGLE_RECAPTCHA_API_KEY = config.services.google.recaptcha_api_key;
const isCaptchaEnabled = GOOGLE_RECAPTCHA_API_KEY !== 'disabled';

const ChannelForm = ({ phone, onSend, onBack }) => {
  const { t } = useTranslation();
  const [error, setError] = useState();
  const [ApiLogin, isSending] = useLazyQuery(Api.login);
  const { register, handleSubmit, watch } = useForm({
    defaultValues: {
      channel: 'sms',
    },
  });
  const { channel } = watch(['channel']);
  const recaptchaRef = useRef();

  const onSubmit = async ({ channel }) => {
    try {
      let token = undefined;

      if (isCaptchaEnabled) {
        token = await recaptchaRef.current.executeAsync();
      }

      await ApiLogin({
        token,
        phone: phone.number,
        prefix: phone.prefix,
        channel,
      });
      onSend && onSend();
      Tracker.pageView('verification code view');
    } catch (error) {
      setError(error);
    }
  };

  return (
    <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
      <FeatureFlag enabled={isCaptchaEnabled}>
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={GOOGLE_RECAPTCHA_API_KEY}
        />
      </FeatureFlag>
      <Form.Field
        readOnly={true}
        label={t('login__choose_channel_phone_label')}
        defaultValue={`(${phone.prefix}) *** *** ${phone.number.slice(-3)}`}
      />
      <div className="mb-4">
        <RadioButton
          key="sms"
          name="channel"
          label={t('login__choose_channel_radio_sms')}
          description={
            channel === 'sms' &&
            t('login__choose_channel_radio_sms_description')
          }
          value="sms"
          register={register({ required: true })}
          checked={channel === 'sms'}
        />
      </div>
      {error && (
        <div className="mb-4 text-sm text-negative">
          {t('login__send_code_form_error')}
        </div>
      )}
      <div className="pb-10 text-center text-dark-medium text-md">
        {t('login__choose_channel_form_retry')}{' '}
        <button
          type="button"
          onClick={onBack}
          className="text-primary hover:text-primary-dark hover:underline"
        >
          {t('login__choose_channel_form_retry_link')}
        </button>
      </div>

      <Button disabled={!channel || isSending} className="ml-auto">
        {isSending
          ? t('login__choose_channel_form_button_loading')
          : t('login__choose_channel_form_button')}
      </Button>
    </form>
  );
};

export default ChannelForm;
